import { Suspense } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { Button, SubTitle } from "../../Components/CustomComponents/index.js";
import Table from "../../Components/Table/Table.js";
import styles from "./styles/user_management.module.scss";
import { Col, Row, Spinner } from "react-bootstrap";
import CustomLoader from "../../Components/CustomComponents/CustomLoader.js";
import DeleteModal from "../../Components/Modals/DeleteModal.js";
import EditVehicleModal from "../../Components/Modals/EditVehicleModal.js";
import VehicleDetailModal from "../../Components/Modals/VehicleDetailModal.js";
import useVehicleManagement from "./Hooks/useVehicleManagement.js";
import VehicleReviewModal from "../../Components/Modals/VehicleReviewModal.js";

const VehicleManagementScreen = () => {
  const {
    rowData,
    editedData,
    editModal,
    detailModal,
    deleteModal,
    reviewModal,
    currentPage,
    pageSize,
    totalRecords,
    totalPages,
    dataFetched,
    isSuccess,
    isLoading,
    isFetching,
    isDeleting,
    refetch,
    reviewData,
    isReviewFetching,
    isReviewLoading,
    isReviewSuccess,
    indication,
    columns,
    handleDeleteModalClose,
    handleDetailModalClose,
    handleEditModalClose,
    handleReviewModalClose,
    handleAddUser,
    deleteData,
    setCurrentPage,
    setPageSize,
    setEditedData,
  } = useVehicleManagement();

  return (
    <div className={styles.MainContainer}>
      {deleteModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <DeleteModal
            handleDeleteModalClose={handleDeleteModalClose}
            data={editedData}
            isDeleting={isDeleting}
            onDelete={deleteData}
          />
        </Suspense>
      ) : (
        ""
      )}

      {detailModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <VehicleDetailModal
            handleModalClose={handleDetailModalClose}
            data={editedData}
            reviewData={reviewData}
            isReviewFetching={isReviewFetching}
          />
        </Suspense>
      ) : (
        ""
      )}

      {/* {reviewModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <VehicleReviewModal
            handleModalClose={handleReviewModalClose}
            editData={editedData}
          />
        </Suspense>
      ) : (
        ""
      )} */}

      {editModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <EditVehicleModal
            handleEditModalClose={handleEditModalClose}
            editData={editedData}
            refetch={refetch}
          />
        </Suspense>
      ) : (
        ""
      )}

      <div className={styles.headerContainer}>
        <div>
          <SubTitle text={"Vehicle Management"} classes="text-black" />
        </div>

        {
          <Row>
            <Col md={12}>
              <Button
                classes={`${styles.cardBtn} `}
                text="Add Vehicle"
                onClick={handleAddUser}
              ></Button>
            </Col>
          </Row>
        }
      </div>

      <div
        className={`${styles.mainTable} ${
          dataFetched && isFetching ? "blur-table" : ""
        }`}
      >
        {!dataFetched || isLoading ? (
          <CustomLoader />
        ) : (
          <div className={styles.mainTable}>
            {
              <Table
                classes={`${dataFetched && isFetching ? "blur-table" : ""}`}
                data={rowData || []}
                columns={columns}
                indication={indication}
                totalRecords={totalRecords} // todo
                totalPages={totalPages} // todo
                pageSize={pageSize} // todo
                currentPage={currentPage} // todo
                setCurrentPage={setCurrentPage} // todo
                setPageSize={setPageSize} // todo
                refetch={refetch} // todo
              />
            }
          </div>
        )}
      </div>
    </div>
  );
};

export default VehicleManagementScreen;
